import { defineComponent as _defineComponent } from 'vue';
import { vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex items-center gap-2 px-4 py-3 bg-white border-t border-gray-100" };
const _hoisted_2 = ["placeholder", "aria-label", "onKeydown"];
const _hoisted_3 = ["disabled", "aria-label"];
import { ref, computed } from 'vue';
import { IconSend } from '@tabler/icons-vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ChatInput',
    emits: ["send"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const text = ref('');
        const inputRef = ref(null);
        const canSend = computed(() => text.value.trim().length > 0);
        function handleSend() {
            const content = text.value.trim();
            if (!content)
                return;
            emit('send', content);
            text.value = '';
            inputRef.value?.focus();
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _withDirectives(_createElementVNode("input", {
                    ref_key: "inputRef",
                    ref: inputRef,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((text).value = $event)),
                    type: "text",
                    class: "flex-1 px-4 py-2.5 text-sm bg-gray-50 border border-gray-200 rounded-full outline-none focus:border-eorange-300 focus:ring-1 focus:ring-eorange-200 transition-colors placeholder-gray-400",
                    placeholder: _ctx.$t('chatbot.auto.escribe_tu_consulta'),
                    "aria-label": _ctx.$t('chatbot.auto.escribe_tu_consulta_jn9va'),
                    onKeydown: _withKeys(_withModifiers(handleSend, ["prevent"]), ["enter"])
                }, null, 40, _hoisted_2), [
                    [_vModelText, text.value]
                ]),
                _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center transition-colors", canSend.value
                            ? 'bg-eorange-500 text-white hover:bg-eorange-600 cursor-pointer'
                            : 'bg-gray-200 text-gray-400 cursor-not-allowed']),
                    disabled: !canSend.value,
                    "aria-label": _ctx.$t('chatbot.auto.enviar_mensaje'),
                    onClick: handleSend
                }, [
                    _createVNode(_unref(IconSend), { size: 18 })
                ], 10, _hoisted_3)
            ]));
        };
    }
});
